import { Severity } from "domain/entities/severity";
import { Result } from "domain/entities/result";
import { SeverityRepository } from "domain/repositories";

export default class UpdateUseCase {
    private severityRepository: SeverityRepository;
    
    public constructor(severityRepository: SeverityRepository) {
        this.severityRepository = severityRepository
    }

    public async updateSeverity(id: number, severity: Severity, token: Promise<[string | null, string | null]>): Promise<[Result, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.severityRepository.updateSeverity(id, severity, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}